import { Container, Indicator } from "./Step.styles";
import { StepProps } from "./Step.types";

export const Step = ({ currentIndex, activeIndex }: StepProps) => (
  <Container>
    <Indicator isActive={currentIndex === activeIndex} position="absolute" />
    <Indicator opacity={currentIndex < activeIndex ? "1" : "0.2"} />
  </Container>
);
